// API Configuration
// In production (Docker), use relative URLs so nginx proxies to backend
// In development, connect directly to backend at localhost:8000
const isProduction = process.env.NODE_ENV === 'production';

// Determine WebSocket protocol based on current page protocol
const getWebSocketBaseUrl = () => {
  if (process.env.REACT_APP_WS_URL) {
    return process.env.REACT_APP_WS_URL;
  }
  if (isProduction) {
    // Use wss:// for HTTPS, ws:// for HTTP
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}`;
  }
  return 'ws://localhost:8000';
};

export const API_BASE_URL = process.env.REACT_APP_API_URL || (isProduction ? '' : 'http://localhost:8000');
export const WS_BASE_URL = getWebSocketBaseUrl();
